// vuelidate.jsのカスタムバリデータ
import { withParams } from 'vuelidate'
import * as $v from 'vuelidate/lib/validators'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
dayjs.locale('ja')
dayjs.extend(advancedFormat)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(duration)
import emojiRegex from 'emoji-regex'

export const required = $v.required
export const requiredIf = $v.requiredIf
export const requiredUnless = $v.requiredUnless
export const minValue = $v.minValue
export const maxValue = $v.maxValue
export const minYen = $v.minValue
export const maxYen = $v.maxValue
export const minNumLength = $v.minLength
export const maxNumLength = $v.maxLength
export const minArrayLength = $v.minLength
export const maxArrayLength = $v.maxLength
export const alpha = $v.alpha
export const alphaNum = $v.alphaNum
export const numeric = $v.numeric
export const email = $v.email
export const sameAs = $v.sameAs
export const or = $v.or
export const and = $v.and

// NOTE: 改行コードを二文字扱いに統一する
const replaceLineFeedCode = value => value.replace(/(\r\n|\r|\n)/g, '\r\n')
export const maxLength = length =>
  withParams({ type: 'maxLength', max: length }, value => {
    if (!value) return true
    return $v.maxLength(length)(replaceLineFeedCode(value))
  })

export const minLength = length =>
  withParams({ type: 'minLength', min: length }, value => {
    if (!value) return true
    return $v.minLength(length)(replaceLineFeedCode(value))
  })

export const between = (min, max) =>
  withParams({ type: 'between', min, max }, value => {
    if (!value) return true
    return $v.between(min, max)(value)
  })

export const regex = pattern =>
  withParams({ type: 'regex', pattern }, value => {
    if (!value) return true
    return new RegExp(pattern).test(value)
  })

export const phoneNumber = withParams({ type: 'phoneNumber' }, value => {
  if (!value) return true
  return new RegExp('^0\\d{1,4}-\\d{1,4}-\\d{4}$').test(value)
})

export const date = withParams({ type: 'date' }, unixtime => {
  if (!unixtime) return true
  return unixtime <= dayjs().unix()
})

export const emoji = withParams({ type: 'emoji' }, text => {
  if (!text) return true
  return !emojiRegex().test(text)
})

export const emailDomain = domainName =>
  withParams({ type: 'emailDomain', domainName }, value => {
    if (!value || !value.includes('@')) {
      return false
    }
    const atIndex = value.indexOf('@')
    const domain = value.substring(atIndex + 1)
    if (domain !== domainName) {
      return false
    }
    return true
  })

// クレジットカード番号のチェックサム
export const luhnChecksum = withParams({ type: 'luhnChecksum' }, value => {
  // Luhnアルゴリズムによるチェック
  const digits = value.split('').reverse()
  let sum = 0
  let x = 0
  for (let i = 0; i < digits.length; i++) {
    x = digits[i] * (1 + (i % 2))
    sum += x > 9 ? x - 9 : x
  }
  if (sum % 10 !== 0) {
    return false
  }

  return true
})

// クレジットカードの過年度チェック
export const expire = withParams({ type: 'expire' }, value => {
  // 過年度チェック
  const now = new Date()
  const now_year = now.getFullYear()
  const now_month = ('00' + (now.getMonth() + 1)).slice(-2)
  return parseInt(value, 10) >= parseInt(now_year + '' + now_month, 10)
})

// 4バイト文字不可
export const char4Byte = withParams({ type: 'emoji' }, text => {
  if (!text) return true

  let includes4Byte = false
  for (var i = 0; i < text.length; i++) {
    try {
      // UTF-16コード1つ
      encodeURIComponent(text.charAt(i))
    } catch {
      try {
        // UTF-16コード2つ
        encodeURIComponent(text.substring(i, i + 2).charAt(1))
      } catch {
        // 4バイト文字はエラーになる
        includes4Byte = true
        break
      }
    }
  }
  return !includes4Byte
})
